import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Container, Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { API_URL } from '../../utils/constants';
import { ProductCard } from './ProductCard';
import { addToCart } from './cartSlice';
import { useNavigate } from 'react-router-dom';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Products: React.FC = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    fetch(`${API_URL}/productOffering`)
      .then(response => response.json())
      .then(data => setProducts(data.map((product: any) => {
        product.initialFee = product.prices.find((price: any) => price.price_type === 'one_time')?.price;
        product.monthlyFee = product.prices.find((price: any) => price.price_type === 'recurring' && price.unit_of_measure === 'month')?.price;
        product.image_name = product.pk.split('#')[1];
        product.image = require(`../../assets/${product.image_name}.jpeg`);
        return product;
      })))
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  const handleAddToCart = (product: any) => {
    dispatch(addToCart({
      id: product.pk,
      name: product.name,
      price: product.initialFee || product.monthlyFee,
      quantity: 1
    }));
    // setOpenSnackbar(true);
    navigate(`/buy-product/${product.pk.split('#')[1]}_${product.prices.find((price: any) => price.price_type === 'recurring' && price.unit_of_measure === 'month')?.pk.split('#')[1]}`);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Grid container spacing={2}>
        {products.map((product, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <ProductCard {...product} showBuyButton={true} onBuyClick={() => handleAddToCart(product)} />
          </Grid>
        ))}
      </Grid>
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
          Product added to cart successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Products;
